import { createSlice } from "@reduxjs/toolkit";
import { GetApps, ConnectApps, GetSettings } from "../thunks/Integration"; // Import GetSettings

const initialState = {
    data: [],
    settings: {},
    processing: false,
    // connectedAppId: localStorage.getItem("connectedAppId") || null,
    // connectedAppId: null,
    // APIKEY: localStorage.getItem("APIKEY") || null,

}

const integrationSlice = createSlice({
    name: "integrationSlice",
    initialState,
    reducers: {
        setConnected: (state, action) => {
            state.connected = action.payload;
        },
        setApiKey: (state, action) => {
            state.apiKey = action.payload;
        },
    },
    extraReducers: {
        [GetApps.pending]: (state) => {
            state.processing = true;
        },
        [GetApps.fulfilled]: (state, { payload }) => {
            state.processing = false;
            state.data = payload;
        },
        [GetApps.rejected]: (state) => {
            state.processing = false;
        },
        [ConnectApps.pending]: (state) => {
            state.processing = true;
        },
        [ConnectApps.fulfilled]: (state, { payload }) => {
            state.processing = false;
            state.connectedAppId = payload.id;
            state.integrationDetails = payload.integration;
            // localStorage.setItem("APIKEY", payload.access_token);

        },
        [ConnectApps.rejected]: (state) => {
            state.processing = false;
        },

        [GetSettings.pending]: (state) => {
            state.processing = true;
        },
        [GetSettings.fulfilled]: (state, { payload }) => {
            state.processing = false;
            state.settings = payload;
        },
        [GetSettings.rejected]: (state) => {
            state.processing = false;
        },
    },
});

export const { setConnected, setApiKey } = integrationSlice.actions;
export default integrationSlice.reducer;
